export const isTouchDevice = () => window.matchMedia('(pointer: coarse) and (hover: none)').matches;

export const isMobile = () => window.innerWidth < 1024;

export const degrees = radians => (radians * 180) / Math.PI;

export const radians = degrees => (degrees * Math.PI) / 180;

export const angleBetween = (v1, v2) => Math.atan2(v2.y - v1.y, v2.x - v1.x);

export const norm = (val, max, min) => (val - min) / (max - min);

export const distanceBetween = (v1, v2) => Math.sqrt((v1.x - v2.x) * (v1.x - v2.x) + (v1.y - v2.y) * (v1.y - v2.y));

export const viewport = () => {
  const viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
    ratio: window.innerWidth / window.innerHeight,
  };

  return viewport;
}

export const lerp = (a, b, n) => ((1 - n) * a) + (n * b);